import React from 'react';
import styled from 'styled-components';

interface TextStatusProps {
  intent?: string;
  children?: React.ReactNode;
}

export function TextStatus({ intent, children }: TextStatusProps) {
  return <TextStatusRoot intent={intent}>{children}</TextStatusRoot>;
}

const TextStatusRoot = styled.span<{ intent?: string }>`
  ${(props) =>
    props.intent === 'warning' &&
    `
  color: #ec5b0a;`}

  ${(props) =>
    props.intent === 'success' &&
    `
  color: #2ba01d;`}

  ${(props) =>
    props.intent === 'none' &&
    `
  color: #777;`}

  ${(props) =>
    props.intent === 'primary' &&
    `
  color: #1652c8;`}
`;
